/**
 * Get the appropriate gender icon SVG path based on the gender value
 * @param {string} gender - The gender value (MALE, FEMALE, etc.)
 * @returns {string} The gender icon SVG path
 */

export function getGenderIcon(gender) {
  switch (gender?.toLowerCase()) {
    case 'male':
      return 'gender-male';
    case 'female':
      return 'gender-female';
    default:
      return 'gender-female';
  }
}
